import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const DisabledWrapper = styled.div`
  border-radius: ${themeStyle.radiusMedium};
  border: 1px solid ${themeStyle.varInkLight};
  padding-left: 12px;
  padding-right: 12px;
  font-size: ${themeStyle.fontSize14};
  font-weight: ${themeStyle.fontMedium};
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${themeStyle.varInkMain};
  gap: 7px;
`;
